import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME as tableName } from './constants';
import { NAME } from '../../constants';

class DoServisuPredalApi extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
		this.apiPath = `${this.apiPath}/${tableName}`;
	}

	async saveTable(vozidloId: number, table: any) {
		return this.update(`${this.apiPath}/${vozidloId}`, table);
	}
}

export const apiProvider = new DoServisuPredalApi();
